import * as routes from 'client/routes/manifest';
import { AppContent } from 'content/AppContent';

import { MetaContentValues } from '../MetaContentValues';

const educationalHub: AppContent['educationalHub'] = {
  metaContent: MetaContentValues.EducationalHub,
  pageTitle: 'Educational Hub',
  backButtonLabel: 'Back',
  backButtonHref: routes.SustainabilityHub,
  iFramePanel: {
    heading:
      'Rewatch our Landlord Regulation webinar with the NRLA and Energy Saving Trust',
    url: 'https://www.youtube.com/embed/4TeNqL_RL6Q?si=AJuU4VNGZ5xkfMuw',
  },
  infoPanel: {
    contentSections: [
      {
        sectionID: 'introduction',
        isAccordion: false,
        sectionBody: [
          {
            text: 'Join Steve Bletsoe from the NRLA, Emma Bill from the Energy Saving Trust, and our own Mark Penfold and Danielle Horton to get ahead with upcoming landlord regulation. Original webinar 26th February 2025.',
          },
        ],
      },
      {
        sectionID: 'broker-training-module',
        isAccordion: false,
        sectionBody: [
          {
            boldText: 'Broker training module',
          },
          {
            text: "Try our broker self-led training modules. They're designed to help improve your understanding and awareness of why sustainability is so important in the housing market and help you have more effective conversations with your customers.",
          },
        ],
      },
      {
        sectionID: 'module-1',
        isAccordion: false,
        sectionBody: [
          {
            boldText: 'Module 1',
          },
          {
            textWithLinks: [
              {
                displayText:
                  'Overview on EPCs, exemptions, and what it means to you',
                external: true,
                href: '/public/overview-on-EPCs-exemptions-and-what-it-means-for-you.pdf',
              },
            ],
          },
        ],
      },
    ],
  },
};

export default educationalHub;
